import {useTranslation} from 'react-i18next';
import Select from 'react-select';
import {useSelector} from 'react-redux';
import { constants } from "../../common/constants/constants";
import {newSelectStyles} from '../../common/shared/select.styled';
import {Datepicker} from '../../common/Datepicker';
import {StyledCommonData} from './expenses.styled';
import InputGroup from '../../common/InputGroup';

export default function ExpensesRecordForm({
   vendors,
   formData,
   onDataChanged,
   onCreationDateChanged,
   onPaymentDateChanged,
   paymentMethods
}) {
    const {t} = useTranslation();
    const isLtrEnabled = useSelector(state => state.common.ltrEnabled);

    return (
        <StyledCommonData>
            <InputGroup
                labelText={`* ${t('expenses.name_of_supplier')}`}
                labelFor={'vendor'}
            >
                <Select
                    styles={newSelectStyles}
                    options={vendors || []}
                    onChange={evt => onDataChanged(evt, 'selectedVendor')}
                    value={formData.selectedVendor}
                    isRtl={!isLtrEnabled}
                />
            </InputGroup>

            <InputGroup
                labelText={`${t('offline_payments.creation_date')}`}
                labelFor={'creationDate'}
            >
                <Datepicker
                    inputProps={{
                        name: 'creationDate'
                    }}
                    placeholder={'dd/mm/yyyy'}
                    defaultValue={new Date()}
                    onDayChange={onCreationDateChanged}
                    styledContainerProps={{
                        isNewDesign: true,
                        isRtl: !isLtrEnabled,
                        className: 'new-design'
                    }}
                />
            </InputGroup>

            <InputGroup
                labelText={`${t('offline_payments.payment_date')}`}
                labelFor={'paymentDate'}
            >
                <Datepicker
                    inputProps={{
                        name: 'paymentDate'
                    }}
                    placeholder={'dd/mm/yyyy'}
                    defaultValue={new Date()}
                    onDayChange={onPaymentDateChanged}
                    styledContainerProps={{
                        isNewDesign: true,
                        isRtl: !isLtrEnabled,
                        className: 'new-design'
                    }}
                />
            </InputGroup>

            <InputGroup
                labelText={`* ${t('expenses.payment_method')}`}
            >
                <Select
                    styles={newSelectStyles}
                    options={paymentMethods || []}
                    onChange={evt => onDataChanged(evt, 'selectedPaymentMethod')}
                    value={formData.selectedPaymentMethod}
                    isRtl={!isLtrEnabled}
                />
            </InputGroup>

            <InputGroup
                labelText={`* ${t('expenses.payment_frequency')}`}
            >
                <Select
                    styles={newSelectStyles}
                    options={[
                        {value: constants.APIContract.expenses.oneTime, label: t('expenses.one_time')},
                        {value: constants.APIContract.expenses.recurring, label: t('expenses.recurring')},
                    ]}
                    onChange={evt => onDataChanged(evt, 'frequency')}
                    value={formData.frequency}
                    isRtl={!isLtrEnabled}
                />
            </InputGroup>
        </StyledCommonData>
    )
}

